/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
export const CONVERSATION_RATING_IDS = {
  AMAZING: 5,
  GREAT: 4,
  OK: 3,
  BAD: 2,
  TERRIBLE: 1
};
export class ConversationRating {
  constructor({
    label,
    labelIntlKey,
    emoji,
    unicode,
    value
  }) {
    this.label = label;
    this.labelIntlKey = labelIntlKey;
    this.emoji = emoji;
    this.unicode = unicode;
    this.value = value;
  }
  get displayName() {
    // Need to use unicode for En Space between the emoji and the label due to a bug in
    // Chrome when rendering emoji on Mac https://bugs.chromium.org/p/chromium/issues/detail?id=1083965&q=emoji&can=2
    return `${this.emoji}\u2002${this.label}`;
  }
}
export const CONVERSATION_RATINGS = [new ConversationRating({
  label: 'Terrible',
  labelIntlKey: 'components.reporting.custom.chart-builder.filter-bar.conversation-rating-filter.ratings.terrible',
  emoji: '😠',
  unicode: '1f620',
  value: CONVERSATION_RATING_IDS.TERRIBLE
}), new ConversationRating({
  label: 'Bad',
  labelIntlKey: 'components.reporting.custom.chart-builder.filter-bar.conversation-rating-filter.ratings.bad',
  emoji: '🙁',
  unicode: '1f615',
  value: CONVERSATION_RATING_IDS.BAD
}), new ConversationRating({
  label: 'Ok',
  labelIntlKey: 'components.reporting.custom.chart-builder.filter-bar.conversation-rating-filter.ratings.ok',
  emoji: '😐',
  unicode: '1f610',
  value: CONVERSATION_RATING_IDS.OK
}), new ConversationRating({
  label: 'Great',
  labelIntlKey: 'components.reporting.custom.chart-builder.filter-bar.conversation-rating-filter.ratings.great',
  emoji: '😃',
  unicode: '1f603',
  value: CONVERSATION_RATING_IDS.GREAT
}), new ConversationRating({
  label: 'Amazing',
  labelIntlKey: 'components.reporting.custom.chart-builder.filter-bar.conversation-rating-filter.ratings.amazing',
  emoji: '🤩',
  unicode: '1f929',
  value: CONVERSATION_RATING_IDS.AMAZING
})];